const DEFAULT_LEVEL = {
    format: 'numeric',
    padding: 2,
    casing: 'upper'
};
export function normalizeNumberingConfig(config) {
    const firstLevel = config?.levels?.[0];
    return {
        format: config?.format ?? firstLevel?.format ?? DEFAULT_LEVEL.format,
        padding: config?.padding ?? firstLevel?.padding ?? DEFAULT_LEVEL.padding,
        casing: config?.casing ?? firstLevel?.casing ?? DEFAULT_LEVEL.casing,
        separator: config?.separator ?? '.'
    };
}
export function numberingConfigFromStyle(input) {
    const normalized = normalizeNumberingConfig({
        format: input.format,
        ...(input.padding !== undefined ? { padding: input.padding } : {}),
        ...(input.casing !== undefined ? { casing: input.casing } : {}),
        ...(input.separator !== undefined ? { separator: input.separator } : {})
    });
    return {
        format: normalized.format,
        padding: normalized.padding,
        casing: normalized.casing,
        separator: normalized.separator,
        levels: [
            {
                format: normalized.format,
                padding: normalized.padding,
                casing: normalized.casing
            }
        ]
    };
}
export function generateNumberedDisplay(config, order, parentDisplay) {
    const normalized = normalizeNumberingConfig(config);
    const local = formatNumber(order + 1, normalized);
    const parent = parentDisplay
        ? stripTrailingSeparator(parentDisplay, normalized.separator)
        : '';
    const display = parent ? `${parent}${normalized.separator}${local}` : local;
    return `${display}${normalized.separator}`;
}
function stripTrailingSeparator(value, separator) {
    if (!separator)
        return value;
    let result = value;
    while (result.endsWith(separator)) {
        result = result.slice(0, -separator.length);
    }
    return result;
}
function formatNumber(n, config) {
    let value;
    switch (config.format) {
        case 'letter':
            value = toLetters(n);
            break;
        case 'roman':
            value = toRoman(n);
            break;
        case 'digit':
        case 'numeric':
            value = String(n).padStart(config.padding, '0');
            break;
        default:
            value = String(n);
    }
    return config.casing === 'lower' ? value.toLowerCase() : value.toUpperCase();
}
function toLetters(n) {
    let value = '';
    let remaining = n;
    while (remaining > 0) {
        remaining -= 1;
        value = String.fromCharCode(65 + (remaining % 26)) + value;
        remaining = Math.floor(remaining / 26);
    }
    return value;
}
function toRoman(n) {
    const romanMap = [
        [1000, 'M'],
        [900, 'CM'],
        [500, 'D'],
        [400, 'CD'],
        [100, 'C'],
        [90, 'XC'],
        [50, 'L'],
        [40, 'XL'],
        [10, 'X'],
        [9, 'IX'],
        [5, 'V'],
        [4, 'IV'],
        [1, 'I']
    ];
    let result = '';
    let remaining = n;
    for (const [value, symbol] of romanMap) {
        while (remaining >= value) {
            result += symbol;
            remaining -= value;
        }
    }
    return result;
}
//# sourceMappingURL=numbering.js.map